const words = ["GRACIA", "ESPÍRITU", "COMUNIDAD", "VERDAD", "AMOR", "RENUEVO", "FE", "VIENTO"];

const Row = () => (
  <div className="flex shrink-0 items-center gap-20 pr-20">
    {words.map((w) => (
      <span key={w} className="flex items-center gap-20">
        <span className="whitespace-nowrap font-serif text-4xl font-semibold italic tracking-wide text-paper/75 sm:text-6xl">
          {w}
        </span>
        <span className="h-1.5 w-1.5 bg-fire" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div className="overflow-hidden border-y border-white/10 bg-ink py-10" data-testid="editorial-marquee">
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </div>
);

export default Marquee;
